export default __webpack_public_path__ + "static/media/ctj.bc57a0d2.JPG";